export default __webpack_public_path__ + "static/media/skull3.a121bb8a.png";